<template>
  <div class="admin-single-image-upload">
    <el-upload
      class="admin-single-image-upload__uploader"
      action="#"
      :show-file-list="false"
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      accept="image/*"
      :disabled="disabled || uploading"
    >
      <div class="admin-single-image-upload__box" :style="boxStyle">
        <template v-if="previewUrl">
          <img :src="previewUrl" class="admin-single-image-upload__pic" :style="boxStyle">
          <div class="admin-single-image-upload__overlay">
            <i class="el-icon-view" title="预览" @click.stop="previewVisible = true" />
            <i class="el-icon-delete" title="删除" @click.stop="clear" />
          </div>
        </template>
        <i v-else-if="!uploading" class="el-icon-plus" />
        <i v-else class="el-icon-loading" />
      </div>
    </el-upload>
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="640px" append-to-body>
      <div style="text-align:center;">
        <img v-if="previewUrl" :src="previewUrl" style="max-width:100%;max-height:70vh;">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { uploadH5AdminImage } from '@/api/h5-admin-seal-stock'

export default {
  name: 'AdminSingleImageUpload',
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    width: { type: [Number, String], default: 120 },
    height: { type: [Number, String], default: 120 }
  },
  data() {
    return {
      uploading: false,
      previewVisible: false
    }
  },
  computed: {
    boxStyle() {
      return {
        width: (typeof this.width === 'number' ? this.width + 'px' : this.width),
        height: (typeof this.height === 'number' ? this.height + 'px' : this.height)
      }
    },
    previewUrl() {
      return this.toFullUrl(this.value)
    }
  },
  methods: {
    toFullUrl(url) {
      if (!url) return ''
      const v = String(url).trim()
      if (/^https?:\/\//i.test(v) || v.startsWith('//') || v.startsWith('data:')) return v
      if (v.indexOf('/upload/') === 0 || v.indexOf('upload/') === 0) {
        return `https://wvxvb.cn/upload/${v.replace(/^\/?upload\/?/, '')}`
      }
      return v
    },
    beforeUpload(file) {
      const ok = file && file.type && file.type.indexOf('image/') === 0
      if (!ok) Message.error('请上传图片文件')
      return ok
    },
    async handleUpload(req) {
      const file = req && req.file
      if (!file) return
      this.uploading = true
      try {
        const res = await uploadH5AdminImage(file)
        const data = (res && res.data) || {}
        const url = data.url || data.link || data.path || ''
        if (!url) throw new Error('上传成功但未返回地址')
        this.$emit('input', url)
      } catch (e) {
        Message.error((e && e.message) || '上传失败')
      } finally {
        this.uploading = false
      }
    },
    clear() {
      this.$emit('input', '')
    }
  }
}
</script>

<style scoped>
.admin-single-image-upload__box {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  background: #fafafa;
  cursor: pointer;
}
.admin-single-image-upload__pic {
  object-fit: contain;
  display: block;
}
.admin-single-image-upload__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 18px;
}
.admin-single-image-upload__box:hover .admin-single-image-upload__overlay {
  display: flex;
}
::v-deep .admin-single-image-upload__uploader .el-upload {
  display: block;
}
</style>
